import dayjs from 'dayjs'
require('dayjs/locale/de')
const localeData = require('dayjs/plugin/localeData')
const isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(localeData)
dayjs.extend(isBetween)

export const getTodaysOpening = openingTimes => {
  if (!openingTimes) return null
  const timeNow = dayjs().locale('de')
  const weekdayString = timeNow.format('dddd')

  const openingTimesToday = openingTimes.find(
    opening => opening.weekday === weekdayString
  )

  const todayIndex = openingTimes.findIndex(
    opening => opening?.weekday === openingTimesToday?.weekday
  )

  const nextOpeningDay = openingTimes[todayIndex + 1] || openingTimes[0]

  let opensTodayAt, closesTodayAt, opensTodayAtSecond, closesTodayAtSecond

  if (openingTimesToday?.open_from && openingTimesToday?.open_until) {
    opensTodayAt = timeNow
      .hour(parseInt(openingTimesToday?.open_from.split(':')[0], 10))
      .minute(parseInt(openingTimesToday?.open_from.split(':')[1], 10))
    closesTodayAt = timeNow
      .hour(parseInt(openingTimesToday?.open_until.split(':')[0], 10))
      .minute(parseInt(openingTimesToday?.open_until.split(':')[1], 10))
  }

  if (
    openingTimesToday?.open_from_second &&
    openingTimesToday?.open_until_second
  ) {
    opensTodayAtSecond = timeNow
      .hour(parseInt(openingTimesToday?.open_from_second.split(':')[0], 10))
      .minute(parseInt(openingTimesToday?.open_from_second.split(':')[1], 10))
    closesTodayAtSecond = timeNow
      .hour(parseInt(openingTimesToday?.open_until_second.split(':')[0], 10))
      .minute(parseInt(openingTimesToday?.open_until_second.split(':')[1], 10))
  }

  const isMarketOpen =
    timeNow.isBetween(opensTodayAt, closesTodayAt) ||
    (opensTodayAtSecond &&
      closesTodayAtSecond &&
      timeNow.isBetween(opensTodayAtSecond, closesTodayAtSecond))

  const isStillToOpenToday =
    timeNow.isBefore(opensTodayAt) || timeNow.isBefore(opensTodayAtSecond)

  return {
    isStillToOpenToday,
    isMarketOpen,
    openingTimesToday,
    nextOpeningDay
  }
}
